import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui";

export interface SendOptions { scheduledAt?: string | null; remindDays?: number | null }

function nextWeekday(hour: number, addDays: number) {
  const d = new Date();
  d.setDate(d.getDate() + addDays);
  d.setHours(hour, 0, 0, 0);
  return d;
}

export function SendControls({ busy, onSend, remindDays, onRemindChange }: { busy: boolean; onSend: (o: SendOptions) => void; remindDays?: number | null; onRemindChange?: (d: number | null) => void }) {
  const [open, setOpen] = useState(false);
  const [custom, setCustom] = useState("");
  const [remind, setRemind] = useState<number | null>(remindDays ?? null);
  const setR = (d: number | null) => { setRemind(d); onRemindChange?.(d); };
  const tomorrow = nextWeekday(8, 1);
  const monday = (() => { const d = nextWeekday(8, 1); while (d.getDay() !== 1) d.setDate(d.getDate() + 1); return d; })();
  const opts = (scheduledAt?: Date | null) => ({ scheduledAt: scheduledAt ? scheduledAt.toISOString() : null, remindDays: remind });
  return (
    <div className="ml-auto row gap-8">
      <select className="select" style={{ width: "auto", height: 28, fontSize: 12 }} value={remind ?? ""} onChange={(e) => setR(e.target.value ? Number(e.target.value) : null)} title="Create a todo if there is no reply">
        <option value="">No reminder</option>
        <option value="2">Remind if no reply: 2d</option>
        <option value="3">Remind if no reply: 3d</option>
        <option value="5">Remind if no reply: 5d</option>
        <option value="7">Remind if no reply: 7d</option>
      </select>
      <div style={{ position: "relative", display: "inline-flex" }}>
        <Button variant="primary" disabled={busy} onClick={() => onSend(opts(null))} style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}>Send</Button>
        <Button variant="primary" disabled={busy} className="icon" aria-label="Send later" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderLeft: "1px solid rgba(255,255,255,.25)" }} onClick={() => setOpen((o) => !o)}><ChevronDown size={14} /></Button>
        {open && (
          <div className="menu" style={{ right: 0, bottom: "calc(100% + 4px)", minWidth: 240 }}>
            <button onClick={() => { setOpen(false); onSend(opts(tomorrow)); }}>Tomorrow 8:00 AM</button>
            <button onClick={() => { setOpen(false); onSend(opts(monday)); }}>Monday 8:00 AM</button>
            <div style={{ padding: "6px 10px" }} className="col gap-4">
              <span className="xs muted">Pick a time</span>
              <input className="input" type="datetime-local" style={{ height: 28 }} value={custom} onChange={(e) => setCustom(e.target.value)} />
              <Button size="sm" disabled={!custom} onClick={() => { setOpen(false); onSend(opts(new Date(custom))); }}>Schedule</Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
